import type { IProductEntity } from '@/features/common/pricing';
import type { ProductMetadataFeature, ProductPrice } from '../entities/ProductMetadata';

import { ProductMetadataBuilder } from './ProductMetadataBuilder';

export class FreeProductMetadataBuilder extends ProductMetadataBuilder {
  getVirtualFeatures(): ProductMetadataFeature[] {
    return ['list_management', 'chrome_extension'];
  }

  override getName(): string {
    return this.products[0].name;
  }

  getIsMostPopular(): boolean {
    return false;
  }

  protected override getPrice(product: IProductEntity): ProductPrice {
    return { price: product.price };
  }

  /**
   * we do not have annual product for free plan, so we return the monthly product,
   * which is the same as the annual product
   */
  override getAnnualProduct(): IProductEntity {
    return this.getMonthlyProduct();
  }

  protected override getAnnualDiscount(): number {
    return 0;
  }
}
